import { Injectable } from '@angular/core';
import { EnvironmentService } from '@core/feature';
import { Snack } from '@main/snackbar/const';
import {
  ADD_SNACK,
  AddSnack,
  CLOSE_SNACK,
  CloseSnack,
  RemoveSnack,
  SET_SNACK,
  SetSnack,
} from '@main/snackbar/data-access';
import { Actions, EffectNotification, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, Observable, iif, of } from 'rxjs';
import { delay, filter, map, mergeMap, tap } from 'rxjs/operators';

@Injectable()
export class SnackbarEffects {
  addSnack$: Observable<AddSnack> = createEffect(() =>
    this.actions$.pipe(
      ofType(SET_SNACK),
      map((action: SetSnack) => action.payload),
      filter((snack: Snack) => !!snack.delay),
      map((snack: Snack) => new AddSnack(snack)),
    ),
  );

  timeoutSnack$: Observable<RemoveSnack> = createEffect(() =>
    this.actions$.pipe(
      ofType(ADD_SNACK),
      map((action: AddSnack) => action.payload),
      filter((snack: Snack) => !!snack.delay),
      mergeMap((snack: Snack) => {
        return of(snack).pipe(
          delay(snack.delay),
          tap(() => {
            snack.onTimeout?.(snack.id);
          }),
          map(() => new RemoveSnack(snack.id)),
        );
      }),
    ),
  );

  closeSnack$: Observable<RemoveSnack> = createEffect(() =>
    this.actions$.pipe(
      ofType(CLOSE_SNACK),
      map((action: CloseSnack) => action.payload),
      tap((snack) => {
        snack.onClose?.(snack.id);
      }),
      map((snack) => new RemoveSnack(snack.id)),
    ),
  );

  constructor(
    private actions$: Actions,
    private environmentService: EnvironmentService,
  ) {}

  ngrxOnRunEffects(resolvedEffects$: Observable<EffectNotification>): Observable<EffectNotification> {
    return iif(() => this.environmentService.isPlatformBrowser, resolvedEffects$, EMPTY);
  }
}
